module.exports = __webpack_public_path__ + "img/rc-back.8aac5387.png";